/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner model module.
 * @module model/OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner
 * @version 1.0.0
 */
class OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner {
    /**
     * Constructs a new <code>OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner</code>.
     * @alias module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner
     */
    constructor() { 
        
        OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner} obj Optional instance to populate.
     * @return {module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner} The populated <code>OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner();

            if (data.hasOwnProperty('rel')) {
                obj['rel'] = ApiClient.convertToType(data['rel'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['rel'] && !(typeof data['rel'] === 'string' || data['rel'] instanceof String)) {
            throw new Error("Expected the field `rel` to be a primitive type in the JSON string but got " + data['rel']);
        }

        return true;
    }


}



/**
 * @member {String} rel
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner.prototype['rel'] = undefined;






export default OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner;

